import { render, staticRenderFns } from "./activityList.vue?vue&type=template&id=038e8f01&scoped=true"
import script from "./activityList.vue?vue&type=script&lang=js"
export * from "./activityList.vue?vue&type=script&lang=js"
import style0 from "./activityList.vue?vue&type=style&index=0&id=038e8f01&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038e8f01",
  null
  
)

export default component.exports